const ArrowRightSvg = (props: any) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 8.67993H12.865L9.232 13.0399C8.878 13.4639 8.936 14.0949 9.36 14.4479C9.785 14.8019 10.415 14.7439 10.769 14.3199L15.769 8.31993C15.808 8.27293 15.827 8.21793 15.856 8.16593C15.88 8.12393 15.909 8.08793 15.927 8.04193C15.972 7.92693 15.999 7.80593 15.999 7.68393C15.999 7.68293 16 7.68093 16 7.67993C16 7.67893 15.999 7.67693 15.999 7.67593C15.999 7.55393 15.972 7.43293 15.927 7.31793C15.909 7.27193 15.88 7.23593 15.856 7.19393C15.827 7.14193 15.808 7.08693 15.769 7.03993L10.769 1.03993C10.57 0.802932 10.286 0.679932 10 0.679932C9.774 0.679932 9.547 0.755932 9.36 0.911932C8.936 1.26493 8.878 1.89593 9.232 2.31993L12.865 6.67993H1C0.448 6.67993 0 7.12793 0 7.67993C0 8.23193 0.448 8.67993 1 8.67993Z"
        fill="white"
      />
    </svg>
  )
}

export default ArrowRightSvg
